// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Patient → Clinical → Problem List only.
 *
 * Same Materialize fight as Medical History: prefixed
 * \`.emr-mz-dashboard td, th { padding: 15px 5px }\` and
 * \`input[type=search]:not(.browser-default) { height: 3rem; margin: 0 0 8px;
 * box-sizing: content-box }\`. Selectors stay under \`.problem-list-section\`
 * so Medical History, Table Designer, and other Clinical tabs are unchanged.
 */

.emr-mz-dashboard .problem-list-section,
.problem-list-section {
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: 16px;
  box-sizing: border-box;
}

.emr-mz-dashboard .problem-list-section *,
.emr-mz-dashboard .problem-list-section *::before,
.emr-mz-dashboard .problem-list-section *::after,
.problem-list-section *,
.problem-list-section *::before,
.problem-list-section *::after {
  box-sizing: border-box;
}

.emr-mz-dashboard .problem-list-section,
.problem-list-section,
.emr-mz-dashboard .problem-list-section h2,
.emr-mz-dashboard .problem-list-section p,
.emr-mz-dashboard .problem-list-section li,
.emr-mz-dashboard .problem-list-section label,
.emr-mz-dashboard .problem-list-section span,
.emr-mz-dashboard .problem-list-section button,
.problem-list-section h2,
.problem-list-section p,
.problem-list-section li,
.problem-list-section label,
.problem-list-section span,
.problem-list-section button {
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: 16px;
}

.emr-mz-dashboard .problem-list-section table.problem-list-table,
.problem-list-section table.problem-list-table {
  display: table !important;
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  position: static;
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: 16px;
}

.emr-mz-dashboard .problem-list-section table.problem-list-table thead,
.problem-list-section table.problem-list-table thead {
  display: table-header-group !important;
  float: none;
  position: static;
}

.emr-mz-dashboard .problem-list-section table.problem-list-table tbody,
.problem-list-section table.problem-list-table tbody {
  display: table-row-group !important;
  float: none;
  position: static;
}

.emr-mz-dashboard .problem-list-section table.problem-list-table tr,
.problem-list-section table.problem-list-table tr {
  display: table-row !important;
  height: 20px;
}

.emr-mz-dashboard .problem-list-section table.problem-list-table th,
.emr-mz-dashboard .problem-list-section table.problem-list-table td,
.problem-list-section table.problem-list-table th,
.problem-list-section table.problem-list-table td {
  display: table-cell !important;
  height: 20px;
  min-height: 20px;
  max-height: 20px;
  padding: 2px 2px;
  padding-top: 2px;
  padding-bottom: 2px;
  line-height: 16px;
  font-family: Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  text-transform: none;
  vertical-align: middle;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.emr-mz-dashboard .problem-list-section table.problem-list-table th,
.problem-list-section table.problem-list-table th {
  font-weight: 600;
}

.emr-mz-dashboard .problem-list-section .problem-list-search,
.emr-mz-dashboard .problem-list-section input.problem-list-search:not([type]),
.emr-mz-dashboard .problem-list-section input.problem-list-search[type="search"]:not(.browser-default),
.emr-mz-dashboard .problem-list-section input.problem-list-search[type="search"],
.problem-list-section .problem-list-search {
  display: block !important;
  appearance: auto !important;
  -webkit-appearance: auto !important;
  box-sizing: border-box !important;
  height: 24px !important;
  min-height: 0 !important;
  max-height: 24px !important;
  margin: 0 !important;
  padding: 2px 8px 2px 28px !important;
  font-family: Arial, sans-serif !important;
  font-size: 16px !important;
  line-height: 16px !important;
}

.emr-mz-dashboard .problem-list-section .problem-list-toolbar-btn,
.problem-list-section .problem-list-toolbar-btn {
  height: 24px;
  min-height: 24px;
  max-height: 24px;
  padding-top: 2px;
  padding-bottom: 2px;
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: 16px;
}

.emr-mz-dashboard .problem-list-section .problem-list-row-btn,
.problem-list-section .problem-list-row-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  max-width: 16px;
  max-height: 16px;
  padding: 0;
  margin: 0;
  line-height: 16px;
}

.emr-mz-dashboard .problem-list-section .problem-list-row-link,
.problem-list-section .problem-list-row-link {
  display: inline-flex;
  align-items: center;
  height: 16px;
  min-height: 16px;
  max-height: 16px;
  padding: 0 4px;
  margin: 0;
  line-height: 16px;
  font-size: 16px;
}

.emr-mz-dashboard .problem-list-section .problem-list-badge,
.problem-list-section .problem-list-badge {
  display: inline-flex;
  align-items: center;
  height: 16px;
  min-height: 16px;
  max-height: 16px;
  padding: 0 4px;
  margin: 0;
  line-height: 16px;
  font-size: 16px;
  border-radius: 2px;
}

.emr-mz-dashboard .problem-list-section table.problem-list-table svg,
.problem-list-section table.problem-list-table svg {
  width: 12px;
  height: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/emr-problem-list.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;;AAEF;;EAEE,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;;EAcE,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,sCAAsC;EACtC,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;EACnC,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;;;;EAIE,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;;EAKE,yBAAyB;EACzB,2BAA2B;EAC3B,mCAAmC;EACnC,iCAAiC;EACjC,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,oCAAoC;EACpC,yCAAyC;EACzC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd","sourcesContent":["/*\n * Patient → Clinical → Problem List only.\n *\n * Same Materialize fight as Medical History: prefixed\n * `.emr-mz-dashboard td, th { padding: 15px 5px }` and\n * `input[type=search]:not(.browser-default) { height: 3rem; margin: 0 0 8px;\n * box-sizing: content-box }`. Selectors stay under `.problem-list-section`\n * so Medical History, Table Designer, and other Clinical tabs are unchanged.\n */\n\n.emr-mz-dashboard .problem-list-section,\n.problem-list-section {\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n  box-sizing: border-box;\n}\n\n.emr-mz-dashboard .problem-list-section *,\n.emr-mz-dashboard .problem-list-section *::before,\n.emr-mz-dashboard .problem-list-section *::after,\n.problem-list-section *,\n.problem-list-section *::before,\n.problem-list-section *::after {\n  box-sizing: border-box;\n}\n\n.emr-mz-dashboard .problem-list-section,\n.problem-list-section,\n.emr-mz-dashboard .problem-list-section h2,\n.emr-mz-dashboard .problem-list-section p,\n.emr-mz-dashboard .problem-list-section li,\n.emr-mz-dashboard .problem-list-section label,\n.emr-mz-dashboard .problem-list-section span,\n.emr-mz-dashboard .problem-list-section button,\n.problem-list-section h2,\n.problem-list-section p,\n.problem-list-section li,\n.problem-list-section label,\n.problem-list-section span,\n.problem-list-section button {\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n}\n\n.emr-mz-dashboard .problem-list-section table.problem-list-table,\n.problem-list-section table.problem-list-table {\n  display: table !important;\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n  position: static;\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n}\n\n.emr-mz-dashboard .problem-list-section table.problem-list-table thead,\n.problem-list-section table.problem-list-table thead {\n  display: table-header-group !important;\n  float: none;\n  position: static;\n}\n\n.emr-mz-dashboard .problem-list-section table.problem-list-table tbody,\n.problem-list-section table.problem-list-table tbody {\n  display: table-row-group !important;\n  float: none;\n  position: static;\n}\n\n.emr-mz-dashboard .problem-list-section table.problem-list-table tr,\n.problem-list-section table.problem-list-table tr {\n  display: table-row !important;\n  height: 20px;\n}\n\n.emr-mz-dashboard .problem-list-section table.problem-list-table th,\n.emr-mz-dashboard .problem-list-section table.problem-list-table td,\n.problem-list-section table.problem-list-table th,\n.problem-list-section table.problem-list-table td {\n  display: table-cell !important;\n  height: 20px;\n  min-height: 20px;\n  max-height: 20px;\n  padding: 2px 2px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  line-height: 16px;\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  letter-spacing: 0;\n  text-transform: none;\n  vertical-align: middle;\n  box-sizing: border-box;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.emr-mz-dashboard .problem-list-section table.problem-list-table th,\n.problem-list-section table.problem-list-table th {\n  font-weight: 600;\n}\n\n.emr-mz-dashboard .problem-list-section .problem-list-search,\n.emr-mz-dashboard .problem-list-section input.problem-list-search:not([type]),\n.emr-mz-dashboard .problem-list-section input.problem-list-search[type=\"search\"]:not(.browser-default),\n.emr-mz-dashboard .problem-list-section input.problem-list-search[type=\"search\"],\n.problem-list-section .problem-list-search {\n  display: block !important;\n  appearance: auto !important;\n  -webkit-appearance: auto !important;\n  box-sizing: border-box !important;\n  height: 24px !important;\n  min-height: 0 !important;\n  max-height: 24px !important;\n  margin: 0 !important;\n  padding: 2px 8px 2px 28px !important;\n  font-family: Arial, sans-serif !important;\n  font-size: 16px !important;\n  line-height: 16px !important;\n}\n\n.emr-mz-dashboard .problem-list-section .problem-list-toolbar-btn,\n.problem-list-section .problem-list-toolbar-btn {\n  height: 24px;\n  min-height: 24px;\n  max-height: 24px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n}\n\n.emr-mz-dashboard .problem-list-section .problem-list-row-btn,\n.problem-list-section .problem-list-row-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  min-width: 16px;\n  min-height: 16px;\n  max-width: 16px;\n  max-height: 16px;\n  padding: 0;\n  margin: 0;\n  line-height: 16px;\n}\n\n.emr-mz-dashboard .problem-list-section .problem-list-row-link,\n.problem-list-section .problem-list-row-link {\n  display: inline-flex;\n  align-items: center;\n  height: 16px;\n  min-height: 16px;\n  max-height: 16px;\n  padding: 0 4px;\n  margin: 0;\n  line-height: 16px;\n  font-size: 16px;\n}\n\n.emr-mz-dashboard .problem-list-section .problem-list-badge,\n.problem-list-section .problem-list-badge {\n  display: inline-flex;\n  align-items: center;\n  height: 16px;\n  min-height: 16px;\n  max-height: 16px;\n  padding: 0 4px;\n  margin: 0;\n  line-height: 16px;\n  font-size: 16px;\n  border-radius: 2px;\n}\n\n.emr-mz-dashboard .problem-list-section table.problem-list-table svg,\n.problem-list-section table.problem-list-table svg {\n  width: 12px;\n  height: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
